import { BaseController } from "./BaseController";

// The AI Assistant on the report (server README, "AI Assistant"). Authorized by the report link.
const AssistantAPI = BaseController.CreateAPI("assistant");

export interface AssistantAction {
	id: string;
	kind: string;
	title: string;
	detail?: string;
	confirmLabel: string;
}

export interface AssistantReply {
	conversationId: string;
	reply: string;
	actions: AssistantAction[];
	// Likely next replies, shown as tap-to-send chips.
	suggestions?: string[];
}

export interface ActionResult {
	status: "done" | "failed" | "cancelled" | string;
	message: string;
	refresh: boolean;
}

export class AssistantError extends Error {}

const CONNECTION_PROBLEM = "Sorry, I couldn't connect just now. Please try again in a moment.";

export const AssistantController = {
	SendMessage: async (payload: {
		enc: string | undefined;
		track: boolean;
		conversationId: string;
		addrId?: number;
		messages: Array<{ role: "user" | "assistant"; content: string }>;
	}): Promise<AssistantReply> => {
		// A few lookups can take a while, so this waits longer than the report's other requests.
		const response = await AssistantAPI.post(`/report/message`, payload, { timeout: 90000 });
		if (response?.status === 200) return response.data;
		throw new AssistantError(response?.data?.message || CONNECTION_PROBLEM);
	},
	DecideAction: async (payload: {
		enc: string | undefined;
		track: boolean;
		actionId: string;
		decision: "confirm" | "cancel";
	}): Promise<ActionResult> => {
		// Adding a property looks up its value, which can take up to a minute.
		const response = await AssistantAPI.post(`/report/action`, payload, { timeout: 120000 });
		if (response?.data?.message) return response.data;
		throw new AssistantError(CONNECTION_PROBLEM);
	},
};
